// extracted by mini-css-extract-plugin
export default {"form":"styles_form__MFYxd","button":"styles_button__DV3YA","center":"styles_center__zcMT1"};